(function () {
  'use strict';

  if (window.SenbederB2BAnalytics) return;

  var dataLayer = window.dataLayer = window.dataLayer || [];
  var privateConfig = window.SenbederPrivateAnalyticsConfig || {};
  var storagePrefix = 'senbeder_private_analytics_';

  function clean(value) {
    return typeof value === 'string' ? value.trim().slice(0, 120) : value;
  }

  function storageValue(key, persistent) {
    try {
      var store = persistent ? window.localStorage : window.sessionStorage;
      var value = store.getItem(storagePrefix + key);
      if (!value) {
        value = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
        store.setItem(storagePrefix + key, value);
      }
      return value;
    } catch (error) {
      return 'unavailable';
    }
  }

  function referrerHost() {
    try {
      return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (error) {
      return '';
    }
  }

  function sourceContext() {
    var params = new URLSearchParams(window.location.search);
    var referrer = referrerHost();
    var source = clean(params.get('utm_source') || (referrer && referrer !== window.location.hostname ? referrer : 'direct'));
    var medium = clean(params.get('utm_medium') || (referrer && referrer !== window.location.hostname ? 'referral' : 'none'));
    return {
      referrer_host: clean(referrer),
      traffic_source: source,
      traffic_medium: medium,
      traffic_campaign: clean(params.get('utm_campaign') || '')
    };
  }

  function privateEndpoint() {
    var endpoint = typeof privateConfig.endpoint === 'string' ? privateConfig.endpoint.trim() : '';
    if (!endpoint || endpoint.indexOf('https://') !== 0) return '';
    return endpoint.replace(/\/+$/, '');
  }

  function sendPrivateEvent(name, parameters) {
    var endpoint = privateEndpoint();
    if (!endpoint || !navigator.sendBeacon) return;
    var payload = Object.assign({
      event: name,
      occurred_at: new Date().toISOString(),
      visitor_id: storageValue('visitor_id', true),
      session_id: storageValue('session_id', false)
    }, pageContext(), sourceContext(), parameters || {});
    try {
      navigator.sendBeacon(endpoint + '/collect', new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' }));
    } catch (error) {
      // Analytics must never interrupt the visitor experience.
    }
  }

  function track(name, parameters) {
    var payload = Object.assign({ event: name }, parameters || {});
    dataLayer.push(payload);
    sendPrivateEvent(name, parameters);

    // The GA4 base tag is loaded through GTM. This direct event call prevents
    // B2B events from needing a separate GTM tag for every event name.
    var attempts = 0;
    function sendToGa4() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, parameters || {});
        return;
      }
      attempts += 1;
      if (attempts < 5) window.setTimeout(sendToGa4, attempts * 350);
    }
    sendToGa4();
  }

  function pageContext() {
    return {
      page_path: window.location.pathname,
      page_title: clean(document.title)
    };
  }

  function clickContext(target) {
    var href = target.getAttribute('href') || '';
    var destination = '';
    var destinationHost = '';
    try {
      if (href) {
        var parsed = new URL(href, window.location.href);
        destination = parsed.origin === window.location.origin ? parsed.pathname : '';
        destinationHost = parsed.hostname.toLowerCase();
      }
    } catch (error) {
      destination = '';
    }
    var section = target.closest('.shopify-section');
    var label = target.dataset.analyticsLabel || target.getAttribute('aria-label') || target.getAttribute('title') || target.innerText || target.textContent || '';
    return {
      interaction_type: target.matches('a') ? 'link' : 'button',
      element_label: clean(label.replace(/\s+/g, ' ')),
      element_id: clean(target.id || ''),
      section_id: clean(section ? section.id : ''),
      destination_path: clean(destination),
      destination_host: clean(destinationHost)
    };
  }

  function productContext(element) {
    var card = element && element.closest('[data-product-id], [data-product-title], [data-product-card]');
    if (!card) return {};
    return {
      product_id: clean(card.dataset.productId || card.dataset.id || ''),
      product_name: clean(card.dataset.productTitle || card.dataset.title || ''),
      product_category: clean(card.dataset.productCategory || card.dataset.category || '')
    };
  }

  function trackInitialViews() {
    var context = pageContext();
    sendPrivateEvent('page_view', context);
    if (window.location.pathname === '/pages/b2b-product-catalog') {
      track('catalog_view', context);
    }
    if (window.location.pathname === '/pages/procurement-list') {
      track('procurement_list_view', context);
    }
    if (document.querySelector('main[data-template="product"]')) {
      track('product_view', context);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button, [role="button"]');
    if (!target || target.closest('[data-private-analytics-ignore]')) return;

    track('ui_click', Object.assign(pageContext(), clickContext(target), productContext(target)));

    var href = (target.getAttribute('href') || '').toLowerCase();
    var contactMethod = href.indexOf('mailto:') === 0 ? 'email'
      : href.indexOf('tel:') === 0 ? 'phone'
        : href.indexOf('https://wa.me/') === 0 || href.indexOf('https://api.whatsapp.com/') === 0 || target.matches('[data-whatsapp-quote]') ? 'whatsapp'
          : '';
    if (contactMethod) {
      track('contact_click', Object.assign(pageContext(), { contact_method: contactMethod }));
      return;
    }

    if (target.matches('[data-add-quote], [data-market-add-quote], [data-product-quote-button]')) {
      track('procurement_list_add', Object.assign(pageContext(), productContext(target)));
      return;
    }

    if (target.matches('[data-open-cart], [data-market-open-quote], [data-product-quote-button]')) {
      track('procurement_list_view', Object.assign(pageContext(), { interaction: 'open' }));
    }
  }, { capture: true });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.matches('.spc-contact-form')) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/contact') !== -1 || form.closest('.shopify-app-block')) {
      track('lead_form_submit', Object.assign(pageContext(), { form_type: 'contact_or_quote' }));
    }
  }, { capture: true });

  window.SenbederB2BAnalytics = { track: track, sendPrivateEvent: sendPrivateEvent };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackInitialViews, { once: true });
  } else {
    trackInitialViews();
  }
})();
